var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "w-100 row",
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "col-md-5" },
        [
          _c("validated-input", {
            attrs: {
              type: "select",
              name: `type`,
              validate: { required: true },
              label: "Type",
              options: [{ text: "Update duplicates", value: 1 }],
            },
            model: {
              value: _vm.item.type,
              callback: function ($$v) {
                _vm.$set(_vm.item, "type", $$v)
              },
              expression: "item.type",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-5" },
        [
          _c("validated-input", {
            attrs: {
              name: `value`,
              validate: { required: true },
              label: "Value",
              "help-options": {
                content: "Provide list of fields to match splited by `;`",
                html: true,
              },
            },
            model: {
              value: _vm.item.value,
              callback: function ($$v) {
                _vm.$set(_vm.item, "value", $$v)
              },
              expression: "item.value",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "col-md-2" }, [
        _c(
          "div",
          { staticStyle: { "margin-top": "32px" } },
          [
            !_vm.item.createdAt
              ? _c(
                  "b-btn",
                  {
                    attrs: {
                      variant: "primary",
                      disabled: _vm.errors.any() || _vm.pending,
                    },
                    on: { click: _vm.submit },
                  },
                  [
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.pending,
                          expression: "pending",
                        },
                      ],
                      staticClass: "far fa-spinner-third fa-spin text-white",
                    }),
                    _vm._v("\n        Save\n      "),
                  ]
                )
              : _vm._e(),
            _vm.item.createdAt
              ? _c("delete-button", {
                  attrs: {
                    title: _vm.item.value || "Action",
                    remove: _vm.remove,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }